import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import Label from '../../../Label';
import styles from './MenuElement.module.css';

const bindClasses = classNameBind.bind(styles);

const MenuElement = ({ data, active, onSelect }) => (
  <div
    role="button"
    tabIndex={0}
    data-ppuc-id="Menu.MenuElement"
    className={bindClasses('element', { active })}
    onClick={() => { onSelect(data); }}
  >
    <Icon name={data.icon} />
    <Label>{data.text}</Label>
  </div>
);

export default MenuElement;
